import React from 'react'
import {
  Snackbar as MUISnackbar,
  SnackbarContent,
  IconButton,
} from '@material-ui/core'
import { CloseIcon, Typography } from 'components'
import { makeStyles } from 'utils'

const Snackbar = ({ message, open, onClose, variant = 'success' }) => {
  const classes = useStyles()
  return (
    <MUISnackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
    >
      <SnackbarContent
        className={classes[variant]}
        message={
          <Typography style={{ color: 'white' }} variant="body1">
            {message}
          </Typography>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </MUISnackbar>
  )
}

export default Snackbar

const useStyles = makeStyles((theme) => {
  // Ensure theme and palette exist with fallbacks to prevent errors
  const safeTheme = theme || {};
  const safePalette = safeTheme.palette || {};
  
  // Define fallback colors
  const defaultColors = {
    primary: '#3f51b5',
    error: '#f44336',
    warning: '#ff9800',
    info: '#2196f3'
  };
  
  // Safe spacing function
  const safeSpacing = (value) => {
    if (safeTheme.spacing && typeof safeTheme.spacing === 'function') {
      return safeTheme.spacing(value);
    }
    return value * 8; // Default MUI spacing is 8px
  };
  
  return {
    success: {
      backgroundColor: safePalette.primary?.main || defaultColors.primary,
    },
    error: {
      backgroundColor: safePalette.error?.main || defaultColors.error,
    },
    warning: {
      backgroundColor: safePalette.warning?.main || defaultColors.warning,
    },
    info: {
      backgroundColor: safePalette.info?.main || defaultColors.info,
    },
    icon: { 
      fontSize: 20 
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: safeSpacing(1),
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
  };
})
